import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StartYourJourney() {
  return <section data-section-id="238781" id="subscribe-for-updates" className="relative w-full bg-primary py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/minimalist_texture.png)] bg-cover bg-center pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-tight text-primary-foreground mb-6 max-w-4xl font-bold tracking-tighter">
          Ready to Clear Your Space? Start Your Ottawa Junk Removal Journey Today.
        </h2>

        <p className="text-primary-foreground/90 text-lg md:text-xl max-w-2xl mb-10 font-default">
          Experience the JUNKR difference with same-day availability, 100% pricing transparency, and local expertise serving Ottawa, Kanata, and Orleans.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <Button asChild size="lg" variant="secondary" className="text-secondary-foreground hover:bg-secondary/90 text-lg h-14 px-10 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 font-default font-semibold w-full sm:w-auto" data-index={0}>
            <Link to="/PricingPage">Get Free Quote</Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground text-lg h-14 px-10 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 font-default font-semibold w-full sm:w-auto bg-transparent" data-index={1}>
            <Link to="/AboutPage">Text Us Photos</Link>
          </Button>
        </div>

        <p className="mt-8 text-sm text-primary-foreground/80 font-default font-medium tracking-wide">
          Fast, friendly, and eco-friendly disposal solutions.
        </p>
      </div>
    </section>;
}